import React, {useEffect, useState} from "react";
import {Box, IconButton, Popover, Tooltip, Typography} from "@mui/material";
import {Apps, Engineering, KeyboardBackspace} from "@mui/icons-material";
import {Blue3} from "../theme/styles";
import css_buttons from "../components/Common/css/CCButton.module.scss";
import {useNavigate} from "react-router-dom";
import EnterpriseObject from "../eoec/eo/EnterpriseObject";
import enterpriseObjectClassFactory from "../eoec/EnterpriseObjectClassFactory";
import AdminUserGroupTableApplet from "../eoec/applet/impl/Administration/AdminUserGroupTableApplet";
import AdminUserGroupEmployeeTableApplet from "../eoec/applet/impl/Administration/AdminUserGroupEmployeeTableApplet";


type MenuSelection = {id: string, target: EventTarget & HTMLButtonElement, option: string | null}

export default function AdministrationUserGroup() {
    const [adminUserGroupEnterpriseObject] = useState(enterpriseObjectClassFactory("AdminUserGroup") as EnterpriseObject);
    const [menu, setMenu] = React.useState<MenuSelection | null>(null);

    const navigate = useNavigate();

    useEffect(() => {
        adminUserGroupEnterpriseObject.getEnterpriseComponent("AdminUserGroup")?.setIDOCRequest("v1.AdminUserGroup-002");
        adminUserGroupEnterpriseObject.getEnterpriseComponent("AdminUserGroup")?.setIDOCResponse("v1.AdminUserGroup-002");

        return () => {}
    }, [adminUserGroupEnterpriseObject]);

    function renderUserGroup() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: "50px", backgroundColor: "#FFFFFF", borderBottom: "1px solid #EDEFF3"}}>
                    <div style={{display: "flex", flexDirection: "row", paddingTop: "9px", marginLeft: "20px", width: "300px"}}>
                        <IconButton
                            className={css_buttons.whiteStandardButton} style={{marginLeft: "-20px", marginTop: "-2px", cursor: "pointer"}} size="small"
                            onClick={() => {
                                navigate("/administration");
                            }}>
                            <KeyboardBackspace sx={{color: "#1498D8", width: "30px", height: "30px"}}/>
                        </IconButton>
                        <Typography style={{fontSize: 20, fontWeight: 500, color: "#1498D8", marginTop: "3px"}}>User Groups</Typography>
                    </div>
                    <div style={{marginRight: "15px", marginTop: "10px"}}>
                        <Tooltip title={"Perspective Selector"}>
                            <IconButton className={css_buttons.blueIconButton} onClick={(e) => setMenu({id: "rolePerspectiveMenu", target: e.currentTarget, option: null})}>
                                <Apps/>
                            </IconButton>
                        </Tooltip>
                        {menu?.id === "rolePerspectiveMenu" ? (
                            <Popover anchorEl={menu.target}
                                     anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                     transformOrigin={{vertical: -11, horizontal: "left"}}
                                     open={true}
                                     onClose={() => setMenu(null)}
                                     TransitionProps={{
                                         onExited: () => setMenu(null),
                                     }}
                                     PaperProps={{
                                         elevation: 2,
                                     }}
                            >
                                <Box sx={{p: 2, bgcolor: "background.paper", width: "450px", height: "280px"}}>
                                    <div style={{display: "flex", flexDirection: "column"}}>
                                        <div style={{padding: "10px", borderBottom: "1px solid #EDEFF3"}}>
                                            <Typography style={{fontSize: 20, fontWeight: 500, color: "#1498D8", marginTop: "3px"}}>Positions List</Typography>
                                            <Typography style={{fontSize: 14, fontWeight: 400, color: "#000000", marginTop: "3px"}}>A list of positions for current company.</Typography>
                                        </div>
                                        <div style={{padding: "10px", borderBottom: "1px solid #EDEFF3"}}>
                                            <Typography style={{fontSize: 20, fontWeight: 500, color: "#1498D8", marginTop: "3px"}}>Positions/Employee List</Typography>
                                            <Typography style={{fontSize: 14, fontWeight: 400, color: "#000000", marginTop: "3px"}}>A list of positions for current company and their assigned employees.</Typography>
                                        </div>
                                        <div style={{padding: "10px"}}>
                                            <Typography style={{fontSize: 20, fontWeight: 500, color: "#1498D8", marginTop: "3px"}}>Positions/Position Hierarchy</Typography>
                                            <Typography style={{fontSize: 14, fontWeight: 400, color: "#000000", marginTop: "3px"}}>A list of positions for current company with a hierarchy visualization.</Typography>
                                        </div>
                                    </div>
                                </Box>
                            </Popover>
                        ) : null}
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", margin: "30px 20px 0 30px"}}>
                    <AdminUserGroupTableApplet enterpriseComponent={adminUserGroupEnterpriseObject?.getEnterpriseComponent("AdminUserGroup")}/>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", margin: "30px 20px 0 30px"}}>
                    <AdminUserGroupEmployeeTableApplet enterpriseComponent={adminUserGroupEnterpriseObject?.getEnterpriseComponent("AdminUserGroupEmployee")}/>
                </div>
            </>
        );
    }

    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                    <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>Administration</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", marginRight: "15px"}}>
                    <Tooltip title={"Administration Menu"}>
                        <IconButton className={css_buttons.blueIconButton2} style={{marginTop: "11px"}} onClick={(e) => setMenu({id: "administrationAppsMenu", target: e.currentTarget, option: null})}>
                            <Apps/>
                        </IconButton>
                    </Tooltip>
                    {menu?.id === "administrationAppsMenu" ? (
                        <Popover anchorEl={menu.target}
                                 anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                 transformOrigin={{vertical: -11, horizontal: "left"}}
                                 open={true}
                                 onClose={() => setMenu(null)}
                                 TransitionProps={{
                                     onExited: () => setMenu(null),
                                 }}
                                 PaperProps={{
                                     elevation: 2,
                                 }}
                        >
                            <Box sx={{p: 2, bgcolor: "background.paper", width: "450px", height: "260px"}}>
                                <div style={{display: "flex", flexDirection: "column", padding: "10px"}}>
                                    <div style={{display: "flex", flexDirection: "row", alignContent: "space-between"}}>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                            <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}} onClick={() => {
                                                setMenu(null)
                                                navigate("/administration/roles");
                                            }}>
                                                <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                            </IconButton>
                                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Roles</Typography>
                                        </div>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                            <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}}>
                                                <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                            </IconButton>
                                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Positions</Typography>
                                        </div>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                            <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}} onClick={() => {
                                                setMenu(null)
                                                navigate("/administration/organizations");
                                            }}>
                                                <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                            </IconButton>
                                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Organizations</Typography>
                                        </div>
                                    </div>
                                    <div style={{display: "flex", flexDirection: "row", alignContent: "space-between", marginTop: "20px"}}>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                            <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}}>
                                                <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                            </IconButton>
                                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>User Groups</Typography>
                                        </div>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                            <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}}>
                                                <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                            </IconButton>
                                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Work Groups</Typography>
                                        </div>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                        </div>
                                    </div>
                                </div>
                            </Box>
                        </Popover>
                    ) : null}
                </div>
            </div>
            {renderUserGroup()}
        </div>
    );
}